import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../../utils/index.js";
import { HorizonContentfulRichText } from "../../HorizonContentfulRichText/index.js";
import { ModuleLayout } from "../Layout/ModuleLayout.js";
const ModuleInfo_ModuleInfo = /*#__PURE__*/ forwardRef(function({ document, renderers, variant = 'marketing', emphasis, display = 'simple', panel = false, children, ...sectionProps }, ref) {
    const richTextClassName = cn('w-full', 'simple' === display && '@2xl:mx-auto @2xl:max-w-192', ('simpleCenter' === display || 'withImageCenter' === display) && '@2xl:mx-auto @2xl:max-w-192');
    const defaultContent = document ? /*#__PURE__*/ jsx(HorizonContentfulRichText, {
        className: richTextClassName,
        document: document,
        renderers: renderers,
        variant: variant,
        emphasis: emphasis
    }) : null;
    return /*#__PURE__*/ jsx(ModuleLayout, {
        ref: ref,
        display: display,
        panel: panel,
        emphasis: emphasis,
        ...sectionProps,
        children: children ?? defaultContent
    });
});
export { ModuleInfo_ModuleInfo as ModuleInfo };
